import styled from '@emotion/styled';
import { MOBILE_QRY } from '~/config';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const ContentWrapper = styled.div`
  flex: 1;
  padding: 24px 16px 0 16px;
`;

export const Footer = styled.div`
  position: sticky;
  bottom: 0;
  z-index: 1;
  background: var(--white);
  padding: 8px 16px;
  border-top: 1px solid var(--border1);

  ${MOBILE_QRY} {
    padding: 18px 34px;
  }
`;
